module.exports = __webpack_public_path__ + "img/course72.6203bec0.png";